import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { DateTime } from "luxon";

export default function ShowScreenDetails({ screen, Toast, getAxiosInstance }) {
  const [IsShowing, setIsShowing] = useState(false);
  const [data, setData] = useState([]);
  const [limit, setLimit] = useState(20);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalScreens, setTotalScreens] = useState(0);
  console.log("renderiing===>", screen);
  console.log("data====>", data);
  function handleClose() {
    setIsShowing(false);
  }

  useEffect(() => {
    if (IsShowing && screen) getScreens();
  }, [screen, pageNumber, IsShowing]);

  const changePage = ({ selected }) => setPageNumber(selected);

  const getScreens = () => {
    let jsonData = {
      id: screen?._id,
      limit: limit,
      page: pageNumber * limit,
    };
    console.log("json data==>", jsonData);
    // converting (json --> form-urlencoded)
    const data = Object.keys(jsonData)
      .map((key) => `${key}=${encodeURIComponent(jsonData[key])}`)
      .join("&");

    getAxiosInstance()
      .post("/admin/screens-availability", data, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
      .then((res) => {
        // Validating form
        if (res.data.status === "success") {
          // console.log(res.data);
          setTotalScreens(res.data.totalCount);
          setData(res.data.result);
        } else if (res.data.status === "error")
          Toast.fire({ icon: "error", title: res.data.message });
        else Toast.fire({ icon: "error", title: "Cannot process request" });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <button
        type="button"
        class="btn btn-secondary btn-sm"
        onClick={() => setIsShowing(true)}
      >
        {screen?.uid || screen?.id}
      </button>
      {IsShowing && (
        <div
          className={`modal fade show`}
          id="modal-default"
          style={{ display: "block", paddingRight: 17 }}
          aria-modal="true"
          role="dialog"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Screens Availability</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={(e) => handleClose()}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div
                className="modal-body"
                style={{ maxHeight: "70vh", overflowY: "auto" }}
              >
                <div className="row">
                  <div className="col-md-12">
                    <table className="table   text-nowrap">
                      <thead>
                        <tr>
                          <th style={{ width: 20 }}>ID</th>
                          <th>Screen</th>
                          <th>Screen ID</th>
                          <th className="text-center">Time</th>
                          <th className="text-center">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.length === 0 && (
                          <tr style={{ textAlign: "center" }}>
                            <td colSpan={8}>No Screen Found</td>
                          </tr>
                        )}
                        {data?.map((screen, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{screen.screen?.name}</td>
                            <td>{screen.screen?.uid || screen.screen?.id}</td>
                            <td className="text-center">
                              {DateTime.fromMillis(screen.timing).toFormat(
                                "dd LLL yyyy h:mm a"
                              )}
                            </td>
                            <td className="text-center">
                              {screen.status === 0 ? (
                                <span class="text-danger">Inactive</span>
                              ) : (
                                <span class="text-success">Active</span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                {totalScreens > limit ? (
                  <ReactPaginate
                    previousLabel={"«"}
                    nextLabel={"»"}
                    pageCount={Math.ceil(totalScreens / limit)}
                    onPageChange={changePage}
                    containerClassName={
                      "pagination pagination-sm m-0 float-right"
                    }
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    // previousClassName={"previous"}
                    previousLinkClassName={"page-link"}
                    // nextClassName={"next"}
                    nextLinkClassName={"page-link"}
                    disabledClassName={"disabled"}
                    activeClassName={"active"}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
